/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {StateService, UIRouter} from '@uirouter/core';
import * as _ from 'lodash';

import template from './not-found-page.component.html';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {NavigationHistoryService} from '../../components/util/navigation-history.service';
import {AppSharedModule} from '../common/app-shared.module';

@Component({
  standalone: true,
  selector: 'adn-not-found-page',
  imports: [AppSharedModule],
  template
})
export class NotFoundPageComponent implements OnInit {
  wrongApp = false;
  appsToGo: string[] = [];

  constructor(
    private readonly $state: StateService,
    @Inject(LocalUserProfile) private readonly localUserProfile: any,
    private readonly uiRouter: UIRouter,
    private readonly navigationHistory: NavigationHistoryService
  ) {
  }

  ngOnInit(): void {
    const appsToGo = this.uiRouter.globals.params.appsToGo;
    this.wrongApp = _.isArray(appsToGo) ? appsToGo.length > 0 : false;
    this.appsToGo = appsToGo || [];
  }

  switchApp(newApp: string): void {
    this.localUserProfile.set('app', newApp);
    if (!this.navigationHistory.previousState) {
      return;
    }
    this.$state.go(this.navigationHistory.previousState.name, this.navigationHistory.previousParams, {
      reload: true
    });
  }
}
